// extracted by mini-css-extract-plugin
export default {"rotate":"awau9LG9d0OWNGVaU3Ty"};